import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { last } from 'lodash';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IconKMSImageIcon from '../../../assets/icons/IconKMSImageIcon';
import IconKMSUpload from '../../../assets/icons/IconKMSUpload';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import MasterDataUserAlert from '../../../components/MasterData/MasterDataUserAlert';
import RadioTab from '../../../components/Radio/RadioTab';
import MENU_NEWS_FEED from '../../../constants/menuNewsFeedConstant';
import API_NEWS_FEED from '../../../api/apiNewsFeed';
import moment from 'moment';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_KMS_UPDATE } from '../../../constants/menuPermissionConstant';

const validationTitle = MENU_NEWS_FEED.validationTitle;
const validationUrlLink = MENU_NEWS_FEED.validationUrlLink;

class NewsFeedEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataNewsFeed: {
                newsFeedId: '',
                title: '',
                description: '',
                imageFile: null,
                urlLink: '',
                status: '',
                createdAt: '',
                createdBy: '',
                updatedAt: '',
            },
            showPopupImage: false,
            showAlertTitle: false,
            showAlertTitleRegex: false,
            showAlertTitleMin: false,
            showAlertTitleMax: false,
            showAlertUrlLinkRegex: false,
            showAlertUrlLinkMax: false,
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
        this.containerRef = createRef()
    }

    handleChange = e => {
        this.setState({
            dataNewsFeed: {
                ...this.state.dataNewsFeed,
                [e.target.name]: e.target.value,
            }
        })
    }

    handleChangeAttachment = e => {
        let tempFile = e.target.files[0];

        if (!tempFile) {
            e.target.value = null;
            return
        }

        if (tempFile.type !== "image/jpeg" && tempFile.type !== "image/png" && tempFile.type !== "image/jpg") {
            e.target.value = null;
            return this.setState({
                errorMessage: "File yang dipilih bukan file gambar (JPEG, PNG & JPG). silahkan pilih file lain",
                showErrorAlertResponse: true
            });
        }

        if (tempFile.size / 1024 / 1024 >= 2) {
            e.target.value = null;
            return this.setState({
                errorMessage: `Maksimal Ukuran file 2Mb!`,
                showErrorAlertResponse: true
            });
        }

        this.setState({
            dataNewsFeed: {
                ...this.state.dataNewsFeed,
                imageFile: tempFile,
            }
        })
    }

    handleCheck = e => {
        this.setState({
            dataNewsFeed: {
                ...this.state.dataNewsFeed,
                [e.target.name]: e.target.value,
            }
        })
    }

    handleValidationField = () => {
        let isFieldError = false;
        this.setState({
            showAlertTitle: false,
            showAlertTitleRegex: false,
            showAlertTitleMin: false,
            showAlertTitleMax: false,
            showAlertUrlLinkMax: false,
            showAlertUrlLinkRegex: false,
        })

        if (this.state.dataNewsFeed.title !== '' && this.state.dataNewsFeed.title.length < 5) {
            this.setState({ showAlertTitleMin: true })
            isFieldError = true;
        }

        if (this.state.dataNewsFeed.title !== '' && this.state.dataNewsFeed.title.length > 50) {
            this.setState({ showAlertTitleMax: true })
            isFieldError = true;
        }

        if (!validationTitle.test(this.state.dataNewsFeed.title)) {
            this.setState({ showAlertTitleRegex: true })
            isFieldError = true;
        }

        if (this.state.dataNewsFeed.title === '') {
            this.setState({ showAlertTitle: true })
            isFieldError = true;
        }

        if (this.state.dataNewsFeed.urlLink !== '' && this.state.dataNewsFeed.urlLink.length > 256) {
            this.setState({ showAlertUrlLinkMax: true })
            isFieldError = true;
        }

        if (this.state.dataNewsFeed.urlLink !== '' && !validationUrlLink.test(this.state.dataNewsFeed.urlLink.trim())) {
            this.setState({ showAlertUrlLinkRegex: true })
            isFieldError = true;
        }

        return isFieldError;
    }

    handleBackToNewsFeedList = () => {
        const getNewsFeedDetailFromHistoryState = this.props.history.location.state.newsFeedDetail;
        this.props.history.goBack();
        this.props.history.push({ state: { newsFeedDetail: getNewsFeedDetailFromHistoryState } });
    }

    handleCancel = () => {
        this.props.history.goBack();
    }

    handleSave = () => {
        if (this.handleValidationField()) {
            return this.containerRef.current.scrollIntoView({ behavior: 'smooth' })
        }
        this.setState({ showConfirmAlert: true })
    }

    successEditNewsFeed = () => {
        this.setState({ showSuccessAlert: false })
        this.handleCancel();
    }

    handleEditNewsFeed = () => {
        this.setState({ showConfirmAlert: false })
        let bodyFormData = new FormData();

        const data = {
            title: this.state.dataNewsFeed.title,
            description: this.state.dataNewsFeed.description,
            url_link: this.state.dataNewsFeed.urlLink.trim(),
            status: this.getBooleanData(this.state.dataNewsFeed.status),
            updated_at: this.state.dataNewsFeed.updatedAt,
            delete_foto: this.state.dataNewsFeed.imageFile ? false : true,
            type: 'N',
        }

        bodyFormData.append('photo1', this.state.dataNewsFeed.imageFile);
        bodyFormData.append('content', JSON.stringify(data));

        API_NEWS_FEED.putDataEditNewsFeed(this.state.dataNewsFeed.newsFeedId, bodyFormData, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showConfirmAlert: false,
                        showSuccessAlert: true,
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    getBooleanData = value => {
        if (value === "false") {
            return false;
        }
        return true;
    }

    getFilenameFromUrl = value => {
        if (value) {
            return last(value.split("/"));
        }
    }

    getDetailNewsFeed = (newsFeedId) => {
        API_NEWS_FEED.getDetailNewsFeed(newsFeedId, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        dataNewsFeed: {
                            newsFeedId: getContent(res).id,
                            title: getContent(res).title,
                            description: getContent(res).description,
                            urlLink: getContent(res).url_link,
                            imageFile: getContent(res).picture_link,
                            status: String(getContent(res).status),
                            createdAt: moment.utc(getContent(res).created_at).format('DD/MM/YYYY HH:mm'),
                            createdBy: `${getContent(res).created_by.first_name} ${getContent(res).created_by.last_name}`,
                            updatedAt: getContent(res).updated_at,
                        },
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                if (err.response.data.nexsoft.payload.status.message === "Data id tidak diketahui") {
                    this.handleBackToNewsFeedList();
                    setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                }
            }))
    }

    componentDidMount() {
        this._isMounted = true;

        let setDefaultValueStatus = "true";
        let newsFeedIdFromHistoryState = this.props.match.params.id;
        this.setState({
            dataNewsFeed: {
                ...this.state.dataNewsFeed,
                status: setDefaultValueStatus
            }
        })
        this.getDetailNewsFeed(newsFeedIdFromHistoryState);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_KMS_UPDATE]} userPermission={this.props.userDetail.permissions}>
                <div ref={this.containerRef} className="h-full mb-5">
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="Berita"
                        menuItem="Ubah Berita"
                        title="Ubah Berita"
                    />

                    {/* WHITECONTAINER */}
                    <div className="white-container pb-24">
                        <div className="w-full bg-white border border-gray-300 rounded-lg p-8">

                            {/* CONTENT */}
                            <div className="relative">
                                <div className="space-x-20 flex">
                                    <div className="space-y-4 flex-initial w-3/12">
                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">ID</p>
                                            </div>
                                            <input
                                                type="text"
                                                name="newsFeedId"
                                                placeholder="Tulis ID"
                                                className="form-control w-full"
                                                value={this.state.dataNewsFeed.newsFeedId}
                                                onChange={this.handleChange}
                                                disabled
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Judul</p>
                                                <span className="text-darkred">*</span>
                                            </div>
                                            <input
                                                id="tsltitle"
                                                type="text"
                                                name="title"
                                                placeholder="Tulis Judul"
                                                className="form-control w-full"
                                                value={this.state.dataNewsFeed.title}
                                                onChange={this.handleChange}
                                                minLength={5}
                                                maxLength={50}
                                            />
                                            {this.state.showAlertTitle && <MasterDataUserAlert text="Judul tidak boleh kosong!" />}
                                            {this.state.showAlertTitleRegex && <MasterDataUserAlert text="Judul hanya boleh mengandung spesial karakter ?" />}
                                            {this.state.showAlertTitleMin && <MasterDataUserAlert text="Jumlah karakter harus lebih besar dari 5" />}
                                            {this.state.showAlertTitleMax && <MasterDataUserAlert text="Jumlah karakter harus lebih kecil dari 50" />}
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Deskripsi</p>
                                            </div>
                                            <textarea
                                                id="tsldescription"
                                                type="textarea"
                                                name="description"
                                                placeholder="Tulis Deskripsi"
                                                className="form-control w-full resize-none h-60"
                                                value={this.state.dataNewsFeed.description}
                                                onChange={this.handleChange}
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Gambar</p>
                                            </div>
                                            {!this.state.dataNewsFeed.imageFile ?
                                                <div className="flex justify-center items-center outline-none border-2 border-gray-300 border-dashed p-5 focus:outline-none">
                                                    <div className="flex flex-col items-center w-full relative space-y-2 text-center text-gray-600">
                                                        <IconKMSUpload />
                                                        <p className="font-bold text-xl">Tarik dan letakkan gambar disini</p>
                                                        <p className="">Jenis file : JPG</p>
                                                        <p className="font-semibold">Atau</p>
                                                        <button className="bg-olddarkblue text-white px-2 py-1 rounded-lg font-medium">Cari File</button>
                                                        <input id="btnattachfile" type="file" className="w-full h-full absolute top-0 left-0 opacity-0" accept="image/png, image/jpg, image/jpeg" onChange={this.handleChangeAttachment} />
                                                    </div>
                                                </div>
                                                :
                                                <div className="flex justify-between p-2 rounded-lg shadow-box-button bg-gray-100 text-gray-600">
                                                    <div className="flex items-center">
                                                        <div className="mr-2">
                                                            <IconKMSImageIcon />
                                                        </div>
                                                        <div className="w-52">
                                                            {(typeof this.state.dataNewsFeed.imageFile) !== "string" ?
                                                                <>
                                                                    <p className="text-lg truncate" title={this.state.dataNewsFeed.imageFile.name}>{this.state.dataNewsFeed.imageFile.name}</p>
                                                                    <p className="text-sm">{Math.round(this.state.dataNewsFeed.imageFile.size / 1024 / 1024 * 100) / 100} MB</p>
                                                                </>
                                                                :
                                                                <>
                                                                    <p className="text-lg truncate" title={this.getFilenameFromUrl(this.state.dataNewsFeed.imageFile)}>{this.getFilenameFromUrl(this.state.dataNewsFeed.imageFile)}</p>
                                                                </>
                                                            }
                                                            <p id="btnviewpicture" className="cursor-pointer text-blue-500" onClick={() => this.setState({ showPopupImage: true })}>Lihat Icon</p>
                                                        </div>
                                                    </div>
                                                    <div className="flex justify-end mt-1 mr-3">
                                                        <FontAwesomeIcon icon={faTimes} className="text-2xl cursor-pointer" onClick={() => { this.setState({ dataNewsFeed: { ...this.state.dataNewsFeed, imageFile: null } }) }} />
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Link URL</p>
                                            </div>
                                            <input
                                                id="tslurllink"
                                                type="text"
                                                name="urlLink"
                                                placeholder="Tulis Link Url"
                                                className="form-control w-full"
                                                value={this.state.dataNewsFeed.urlLink}
                                                onChange={this.handleChange}
                                                maxLength={256}
                                            />
                                            {this.state.showAlertUrlLinkRegex && <MasterDataUserAlert text="Url harus mengandung format http:// atau https://" />}
                                            {this.state.showAlertUrlLinkMax && <MasterDataUserAlert text="Jumlah karakter harus lebih kecil dari 256" />}
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Status</p>
                                                <span className="text-darkred">*</span>
                                            </div>
                                            <RadioTab id="tglstatus" radioInputName="status" dataOption={MENU_NEWS_FEED.dataStatus} defaultCheck={this.state.dataNewsFeed.status} onChange={this.handleCheck} />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Tanggal Pembuatan</p>
                                            </div>
                                            <input
                                                type="text"
                                                name="createdAt"
                                                placeholder="Tanggal Pembuatan"
                                                className="form-control w-full"
                                                value={this.state.dataNewsFeed.createdAt}
                                                onChange={this.handleChange}
                                                disabled
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Dibuat Oleh</p>
                                            </div>
                                            <input
                                                type="text"
                                                name="createdBy"
                                                placeholder="Dibuat Oleh"
                                                className="form-control w-full"
                                                value={this.state.dataNewsFeed.createdBy}
                                                onChange={this.handleChange}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Button */}
                                <div className="flex space-x-5 absolute -bottom-24 -right-8">
                                    <button className="border border-olddarkblue bg-transparent text-olddarkblue py-2 px-6 rounded-lg font-medium" onClick={this.handleCancel}>Batal</button>
                                    <button className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={this.handleSave}>Simpan</button>
                                </div>

                                {/* Popup Modal Image */}
                                <div className={this.state.showPopupImage ? "block" : "hidden"}>
                                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                                        <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none w-5/12 min-w-min">
                                            <div className="body-attachment w-full flex rounded-lg flex-col p-8 font-bold text-lg space-y-5">
                                                <div>
                                                    <div className="text-2xl">{this.state.dataNewsFeed.imageFile ? this.state.dataNewsFeed.imageFile.name : ''}</div>
                                                </div>
                                                <div className="flex justify-center items-center">
                                                    <img src={this.state.dataNewsFeed.imageFile && this.state.dataNewsFeed.imageFile} alt={this.state.dataNewsFeed.imageFile ? this.state.dataNewsFeed.imageFile.name : ''} className="h-96" />
                                                </div>
                                                <div className="flex justify-center items-center">
                                                    <button id="btncloseviewicon" className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={() => this.setState({ showPopupImage: false })}>Tutup</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAlert} button={true} title="Ubah Berita?" desc={"Data otomatis akan tersimpan di Berita"} close={() => this.setState({ showConfirmAlert: false })} submit={this.handleEditNewsFeed} />
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc={"Data berhasil disimpan!"} close={this.successEditNewsFeed} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsFeedEdit);